import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Menu, Dropdown } from 'antd';

import { updateAuthenticationUserData } from 'app/actions/Users/users.action';
import { useSelector, useDispatch } from 'react-redux';

import withTranslations from 'app/components/HOGs/withTranslations';

import { LengthType } from '../../../../constants/user.constants';

import userAPI from '../../../../API/user.service.api';

const getCheckIcon = (s, t) =>
  t === s ? (
    <div className="unitLengthCheckbox" />
  ) : (
    <div
      style={{ display: 'inline-flex', width: 12, height: 12, marginRight: 8 }}
    />
  );

const ConvertDistance = (props) => {
  const { type, distance = 0, duration = 0, className, style, tr } = props;
  let hour;
  const unitOfLenght =
    type === LengthType.M
      ? `${Math.round(distance * 0.000621371192)} ${tr.miles}`
      : `${Math.floor(distance / 1000)} ${tr.km}`;

  if (duration) {
    const sec = duration;
    const h = (sec / 3600) ^ 0; // eslint-disable-line no-bitwise
    const m = ((sec - h * 3600) / 60) ^ 0; // eslint-disable-line no-bitwise

    hour = `${h} ${tr.h} ${m} ${tr.min}`;
  } else {
    hour = `0 ${tr.h} 0 ${tr.min}`;
  }

  return (
    <div style={style || {}} className={className}>
      {`${unitOfLenght} | ${hour}`}
    </div>
  );
};

const TimeAndDistanceFullView = (props) => {
  const { tr } = props;
  const { user, isLoggedIn } = useSelector((store) => store.authentication);
  const dis = useSelector(
    (store) => store.tourFullData.activeMultiPart.distance
  );
  const dur = useSelector(
    (store) => store.tourFullData.activeMultiPart.duration
  );
  const distance = props.distance !== undefined ? props.distance : dis;
  const duration = props.duration !== undefined ? props.duration : dur;
  const isFullScreenModeEnabled = useSelector(
    (store) => store.tourFullData.isFullScreenModeEnabled
  );

  const dispatch = useDispatch();
  const { KM, M } = LengthType;
  const [meas, setMease] = useState(LengthType.KM);

  useEffect(() => {
    if (isLoggedIn) {
      setMease(user.units);
    }
  }, [isLoggedIn]);

  const handleClick = (key) => {
    setMease(key);
    dispatch(updateAuthenticationUserData({ ...user, units: key }));
    userAPI.update({ unit_of_length: key });
  };

  const menu = (
    <Menu onClick={({ key }) => handleClick(key)}>
      <Menu.Item key={LengthType.KM}>
        {getCheckIcon(meas, LengthType.KM)}
        {tr[KM]}
      </Menu.Item>
      <Menu.Item key={LengthType.M}>
        {getCheckIcon(meas, LengthType.M)}
        {tr[M]}
      </Menu.Item>
    </Menu>
  );

  const component = (
    <Dropdown overlay={menu} placement="top" trigger={['click']}>
      <span style={{ cursor: 'pointer' }}>
        <ConvertDistance
          type={meas}
          distance={distance}
          duration={duration}
          style={{ paddingLeft: '10px' }}
          tr={tr}
        />
      </span>
    </Dropdown>
  );

  const getFullMap = () => (
    <div className="fullMapDistDurLayout">{component}</div>
  );

  return isFullScreenModeEnabled
    ? ReactDOM.createPortal(
        getFullMap(),
        document.querySelector('.TourFullmap')
      )
    : component;
};

export default withTranslations(TimeAndDistanceFullView);
